import { Header1 } from '../../components/primitives/Text'

export default function NotFound() {
  return (
    <Header1 css={{m: '$36'}}>Error 404 - Page not found</Header1>
  )
}
